import components from "./components";
import palette from "./palette";
const theme = {
    spacing: 1,
    palette,
    components,
};
export default theme;
